// Key-value mapping for crops based on provided data, with swapped key-value
const namemapping = {
    "Horse Gram": "HORSE GRAM",
    "Red Gram": "RED GRAM",
    "Green Gram": "GREEN GRAM",
    "Potatoes": "POTATO",
    "Groundnut": "GROUNDNUT",
    "Maize": "MAIZE",
    "Gingelly": "GINGELLY",
    "Paddy": "PADDY",
    "Cotton": "COTTON",
    "Ragi": "RAGI",
    "Cumbu": "CUMBU",
    "Sorghum": "CHOLAM", // Assuming "Sorghum" is "Cholam"
    "Bengal Gram": "BENGAL GRAM",
    "Onion": "ONION",
    "Black Gram": "BLACK GRAM",
    "Sugarcane": "SUGARCANE"
  };
  
  export default namemapping;
  